import {createContext} from '@lit/context';
import {WishlistRouter} from '../../templates/components/wishlist-app/wishlist-router.js';

export interface WishlistAppConfig {
  favoritesEndpoint: string
  collectionEndpoint: string
  favoritesEndpoints: string[]
  collectionEndpoints: string[]
  loginEndpointWithFavoritesReferrer: string
  loginEndpointWithFavoritesEventLayerOpenReferrer: string
  loginEndpointWithCollectionReferrer: string
  productEndpoint: string,
  mixAndMatchEndpoint: string
  productLineEndpoint: string
  capsuleEndpoint: string
  eventsEndpoint: string
  eventsSeenEndpoint: string
  eventsAppLayerEndpoint: string,
  isAppNativeBottomSheetEnabled: boolean,
  surveyCollectorId: string,
  surveyEnabled: boolean,
  showChristmasBear: boolean
  // === abtest-ents-t6727-favoriten-artikelkachel-redesign Product Tile Redesign START ===
  productTileRedesign: boolean
  // === abtest-ents-t6727-favoriten-artikelkachel-redesign Product Tile Redesign END ===
}

export const wishlistAppConfigContext = createContext<WishlistAppConfig>('wishlistAppConfigContext');
export const wishlistRouterContext = createContext<WishlistRouter>('wishlistRouterContext');
